"use client"

const GlassBox = () => {
    if (typeof document !== 'undefined') {
        const script = document.createElement('script');
        script.setAttribute('id', '_cls_detector');
        script.setAttribute('src', 'https://cdn.gbqofs.com/careforsons/p/detector-dom.min.js');
        script.setAttribute('async', '');
        document.head.appendChild(script);
    }
}

export default GlassBox;
